import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import "./NewsDetails.css";
import NewsData from './NewsData.json'
import Container from "../../components/Container/Container";
import Body from "../../components/Body/Body";
import { Button } from "antd";
import RichTextEditor from '../../components/RichTextEditor/RichTextEditor';

const createSlug = (title) => {
    return title.toLowerCase()
        .replace(/[^a-z0-9]+/g, '-') 
        .replace(/^-+|-+$/g, ''); 
};

const NewsDetail = () => {
    const [edit, setEdit] = useState(false)
    const { slug } = useParams();
    const newsItem = NewsData.articles.find(
        news => createSlug(news.title) === slug
    );
    
    const [content, setContent] = useState(`
        <h1>${newsItem?.title || ""}</h1>
        <img src="${newsItem?.urlToImage || ""}" style="width:50%; max-height:200px; object-fit:cover;" />
        <p>${newsItem?.content || ""}</p>
    `);

    if (!newsItem) {
        return <h2>Bài viết không tồn tại!</h2>;
    }

    return (
        <Container>
            <Body>
            {
                edit
                ?    
                <RichTextEditor backBtn={()=>setEdit(false)} 
                     value={content} 
                    onChange={(newContent) => setContent(newContent)} 
                />
                :
                <div className="news-detail">
                    <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                        <h1>{newsItem.title}</h1>
                        <Button onClick={()=>setEdit(true)}>Chỉnh sửa bài viết</Button>
                    </div>
                    <img src={newsItem.urlToImage} alt={newsItem.title} />
                    <p>{newsItem.description}</p>
                </div>
            }
            </Body>
        </Container>
    );
};

export default NewsDetail;
